
import Vue from 'vue'
import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('user')
import { RInput, RButton, RCard } from '@/components'

type PhoneSubmit = {
  phone: string
}

export default Vue.extend({
  name: 'PhoneSubmit',
  components: {
    RInput,
    RButton,
    RCard,
  },
  props: {
    errorMessage: {
      type: String,
      required: false,
    },
  },
  data(): PhoneSubmit {
    return {
      phone: '',
    }
  },
  methods: {
    submit() {
      const category: string = 'CALL REQUEST',
        description: string = this.phone,
        additionalDetails: string = this.errorMessage,
        userAgent: string = window.navigator.userAgent

      this.reportBug({
        category,
        description,
        additionalDetails,
        userAgent,
      })
    },
    ...mapActions(['reportBug']),
  },
  computed: {
    ...mapGetters(['bugReportRequest']),
    submitDisabled(): boolean {
      // min phone number with country code length is 7
      // https://www.quora.com/What-is-maximum-and-minimum-length-of-any-mobile-number-across-the-world
      return this.bugReportRequest.pending || this.phone.length < 7
    },
  },
  watch: {
    bugReportRequest(newValue) {
      if (newValue.successful) {
        this.phone = ''
      }
    },
  },
})
